import { createBrowserRouter, RouterProvider } from "react-router-dom";

import About from "./pages/About";
import Homepage from "./pages/Homepage";
import Party from "./pages/Party";
import Parties from "./pages/Parties";
import JoinUs from "./pages/JoinUs";
import Creatures from "./pages/Creatures";
import Creature from "./pages/Creature";
import Author from "./pages/Author";
import FourOhFour from "./pages/FourOhFour";

const App = () => {

const router = createBrowserRouter([
  {
    path: "/",
    element: <Homepage />,
  },
  {
    path: "/creatures",
    element: <Creatures />,
  },
  {
    path: "/creatures/:creatureid",
    element: <Creature />,
  },
  {
    path: "/authors/:authorid",
    element: <Author />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/join-us",
    element: <JoinUs />,
  },
  {
    path: "/parties",
    element: <Parties />,
  },
  {
    path: "/parties/:partyid",
    element: <Party />,
  },
  {
    path: "*",
    element: <FourOhFour />,
  },
]);


  return <RouterProvider router={router} />
};

export default App;